import { render } from "./DigitalProjectEfficiency.vue?vue&type=template&id=76a7e926"
import script from "./DigitalProjectEfficiency.vue?vue&type=script&lang=js"
export * from "./DigitalProjectEfficiency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__